import { useEffect, useState } from "react";

/** Chrome/Android fires beforeinstallprompt; returns a prompt() when the app is installable. */
export const useInstallPrompt = () => {
  const [event, setEvent] = useState(null);
  const [installed, setInstalled] = useState(
    () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true
  );

  useEffect(() => {
    const onPrompt = (e) => { e.preventDefault(); setEvent(e); };
    const onInstalled = () => { setInstalled(true); setEvent(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const install = async () => {
    if (!event) return "unavailable";
    event.prompt();
    const { outcome } = await event.userChoice;
    setEvent(null);
    return outcome;
  };

  return { canInstall: !!event, installed, install };
};

export const isAndroid = () => /Android/i.test(navigator.userAgent);
